module.exports = __webpack_public_path__ + "static/media/HCMM266.07346cf9.jpg";